import apiFetch from '../apiFetch'

export default function (idEscandallo, token) {
  return apiFetch({endPoint: `Escandallo/cambiarEstadoEscandallo?idEscandallo=` + idEscandallo, method: 'GET', body: null, token: token})
}